import { PriorityFilterStatus } from "@/enum/list.enum";

/**
 * Every scored lead: the three qualified priorities, disqualified, and "?" — a lead scoring could
 * not judge, which was stored as disqualified until PREC-4075 and must not drop out of a review
 * session because it no longer is. NB this must be the explicit P1/P2/P3 set, NOT
 * `ALL_WITH_PRIORITY`: the backend collapses `ALL_WITH_PRIORITY` to priorities 1/2/3 and drops the
 * rest when both are present.
 */
const EVERY_SCORED_LEAD: PriorityFilterStatus[] = [
	PriorityFilterStatus.P1,
	PriorityFilterStatus.P2,
	PriorityFilterStatus.P3,
	PriorityFilterStatus.DQ,
	PriorityFilterStatus.UNSURE,
];

/**
 * Resolves the initial score/priority filter for the Ready-to-Send (Review) screen from the URL.
 *
 * An explicit `priorityFilterStatus` param always wins. Otherwise, a review session reviews a
 * hand-picked set of leads, so the score filter defaults to every scored lead (all qualified
 * priorities, disqualified and "?") rather than only the prioritised ones. Normal Review browsing
 * keeps the previous default of `ALL_WITH_PRIORITY`. See PREC-3502, PREC-4075.
 */
export const getInitialPriorityFilter = (search: string): PriorityFilterStatus[] => {
	const params = new URLSearchParams(search);
	const param = params.get("priorityFilterStatus");

	if (param) {
		try {
			return JSON.parse(param) as PriorityFilterStatus[];
		} catch {
			// fall through to the defaults below
		}
	}

	if (params.get("reviewSessionId")) {
		return EVERY_SCORED_LEAD;
	}

	return [PriorityFilterStatus.ALL_WITH_PRIORITY];
};
